/**
 * A contagem do `Checklist`, fora do componente para ter teste.
 *
 * Na mesa do sinistro, três coisas saem desta conta: a lista "Obrigatórios
 * para avançar" (com o "1 de 7"), o selo do rodapé ("6 obrigatórios
 * pendentes") e o bloqueio do "Salvar e mover". **As três saem da mesma
 * função** — é a regra 2 dos formulários do sinistro aplicada à fase: duas
 * contas para a mesma pergunta acabam discordando, e aí a lista diz "pronto"
 * enquanto o botão recusa.
 */

/**
 * O estado de um item.
 *
 * - `done` — cumprido (campo preenchido, documento validado);
 * - `pending` — falta;
 * - `review` — chegou e ainda falta conferir (documento recebido, não
 *   validado). **Não conta como cumprido**: quem conta é quem confere;
 * - `skipped` — não se aplica a este registro. Sai do total, para o
 *   contador não exigir o que não existe.
 */
export type ChecklistStatus = 'done' | 'pending' | 'review' | 'skipped';

export interface ChecklistProgress {
  /** Quantos contam — o total sem os que não se aplicam. */
  total: number;
  done: number;
  /** As chaves do que falta, na ordem da lista — `pending` e `review`. */
  missing: string[];
  /** Nada falta. Lista vazia está completa: não há o que exigir. */
  complete: boolean;
}

export function checklistProgress(
  items: readonly { key: string; status: ChecklistStatus }[],
): ChecklistProgress {
  const counted = items.filter((item) => item.status !== 'skipped');
  const missing = counted
    .filter((item) => item.status !== 'done')
    .map((item) => item.key);
  return {
    total: counted.length,
    done: counted.length - missing.length,
    missing,
    complete: missing.length === 0,
  };
}
